// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import React from 'react';
import EventTypeColorKey from "./EventTypeColorKey";
import {IConfigurableChoice} from "../../ConfigurableChoice";
import { Toast } from '../../toast';

export interface IFilter { eventType: string, eventFormat: string, eventLocation: string, eventSelection: string }
interface IEventFilterProps {
    EventTypes: Array<IConfigurableChoice>,
    EventFormats: Array<IConfigurableChoice>, 
    EventLocations: Array<IConfigurableChoice>, 
    UpdateFilter: (filter: IFilter) => void, 
    Filter: IFilter, 
    HideAllEventsRadio?: boolean,
    HideMyEventsRadio?: boolean,
    HideMyMisoCalendarRadio?: boolean,
    HideMyMisoCalendar?: boolean,
    IsLoggedIn?: boolean,
    LoginUrl?: string
}
interface State { filter: IFilter }

export default class EventFilters extends React.Component<IEventFilterProps, State>{
    constructor(props){
        super(props);        
        this.state = { filter: this.props.Filter };
    }

    private static LOGIN_TOAST_MESSAGE = "Please login to access 'My MISO Calendar' to add/remove meetings and committee subscriptions. If you do not have a MISO Public Website account, click on 'Create Profile' below to create an account.";

    private onFilter(choice, value){
        if (choice === 'eventSelection' && value === 'myMiso' && !this.props.IsLoggedIn) {
            Toast.SetPendingToast(EventFilters.LOGIN_TOAST_MESSAGE, 'My MISO Calendar', 'info');
            var loginUrl = this.props.LoginUrl || '/login';
            var separator = window.location.search ? '&' : '?';
            var returnUrl = encodeURIComponent(window.location.pathname + window.location.search + separator + 'eventSelection=myMiso' + window.location.hash);
            window.location.href = loginUrl + '?returnUrl=' + returnUrl;
            return;
        }

        var filter = this.state.filter;        
        filter[choice] = value;        
        this.setState({filter: filter});
        this.props.UpdateFilter(filter);

    }

    private RenderConfigurableChoices(choices: Array<IConfigurableChoice>){
        if(choices != null){
            return(
                choices.map((choice, i) => {
                    return(
                        <option key={i} value={choice.value}>{choice.text}</option>
                    )
                })
            )
        }
    }

    render() {
        return(
            <div className="row">
                <div className="col-12 col-md-6">
                    <h3 className="blue">
                        Filter Calendar By
                    </h3>
                </div>
                <div className="col-12 col-md-6">
                    <EventTypeColorKey EventTypes={this.props.EventTypes} />
                </div>
                <div className="clearfix" />
                <div className="col-12 col-md-3">
                    <div className="form-group">                        
                        <label htmlFor="filterEventType">Meeting Type </label>&nbsp;
                        <select className="form-select" id="filterEventType" value={this.state.filter.eventType} onChange={(event: React.FormEvent<HTMLSelectElement>) => {this.onFilter('eventType', (event.target as HTMLSelectElement).value);} }>
                            <option value="All">All</option>
                            { this.RenderConfigurableChoices(this.props.EventTypes) }
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">                        
                        <label htmlFor="filterEventFormat">Meeting Format </label>&nbsp;
                        <select className="form-select" id="filterEventFormat" value={this.state.filter.eventFormat} onChange={(event: React.FormEvent<HTMLSelectElement>) => {this.onFilter('eventFormat', (event.target as HTMLSelectElement).value);}}>
                            <option value="All">All</option>
                            { this.RenderConfigurableChoices(this.props.EventFormats) }
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">                        
                        <label htmlFor="filterEventLocation">Location </label>&nbsp;
                        <select className="form-select" id="filterEventLocation" value={this.state.filter.eventLocation} onChange={(event: React.FormEvent<HTMLSelectElement>) => {this.onFilter('eventLocation', (event.target as HTMLSelectElement).value);}}>
                            <option value="All">All</option>
                            { this.RenderConfigurableChoices(this.props.EventLocations) }
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-3 flexContainer">
                    {!this.props.HideAllEventsRadio &&
                        <div className="radio">
                            <label>
                                <input type="radio" name="eventSelection" id="eventSelectionAll" value="all" checked={this.state.filter.eventSelection == "all"} onChange={(event: React.FormEvent<HTMLInputElement>) => { this.onFilter('eventSelection', "all") }} />
                                All Meetings
                            </label>
                        </div>
                    }
                    {!this.props.HideMyEventsRadio && this.props.HideMyMisoCalendar &&
                        <div className="radio">
                            <label>
                                <input type="radio" name="eventSelection" id="eventSelectionRegistered" value="registered" checked={this.state.filter.eventSelection == "registered"} onChange={(event: React.FormEvent<HTMLInputElement>) => { this.onFilter('eventSelection', "registered") }} />
                                My Meetings
                            </label>
                        </div>
                    }
                    {(!this.props.HideMyMisoCalendarRadio && !this.props.HideMyMisoCalendar) &&
                        <div className="radio">
                            <label>
                                <input type="radio" name="eventSelection" id="eventSelectionMyMiso" value="myMiso" checked={this.state.filter.eventSelection == "myMiso"} onChange={(event: React.FormEvent<HTMLInputElement>) => { this.onFilter('eventSelection', "myMiso") }} />
                                My MISO Calendar
                            </label>
                        </div>
                    }
                </div>
            </div>
        )
    }
}